module.exports = angular.module('cartographer.app.form.inputGroup', [])

_ = require 'underscore'

# A list-of-inputs form field that adds and removes values from a `selected` array.
#
# Possible values and labels are specified in an `options` array as follows:
#   [ { value: valueForModel, label: stringToPlaceOnScreen }, ... ]
#
# You can override the default keys 'value' and 'label' using the attributes
# `value-key` and `label-key` respectively.
module.exports.factory 'crtInputGroupDirective', $DI (crtLog, crtString) ->
  return (directiveName, template) ->
    return {
      restrict: 'A'
      require: directiveName
      scope:
        options       : '='
        selected      : '='
        valueKey      : '=?'
        labelKey      : '=?'
        enabled       : '=?'
        showOption    : '=?' # option -> boolean
        enableOption  : '=?' # option -> boolean
        indentOption  : '=?' # option -> boolean
      template: template
      controller: $DI ($scope) ->
        crtInputGroup = this

        $scope.valueKey     ?= 'id'
        $scope.labelKey     ?= 'name'
        $scope.enabled      ?= true
        $scope.showOption   ?= (option) -> true
        $scope.enableOption ?= (option) -> true
        $scope.indentOption ?= (option) -> false
        $scope.layout       ?= 'block'

        return crtInputGroup
      link: ($scope, element, attrs, controllers) ->
        crtInputGroup = controllers

        $scope.layout     = attrs.layout ? 'block'
        $scope.showValues = crtString.booleanAttr(attrs.showValues)

        # option -> boolean
        $scope.optionSelected = (option) ->
          !!_.find($scope.selected, (item) -> item == option[$scope.valueKey])

        # option -> void
        $scope.optionClicked = (option) ->
          if $scope.optionSelected(option)
            $scope.selected = _.reject $scope.selected, (selected) ->
              _.isEqual(selected, option[$scope.valueKey])
          else
            $scope.selected = _.union($scope.selected, [ option[$scope.valueKey] ])

          crtLog.debug("#{directiveName}.optionClicked", option, $scope.optionSelected(option), $scope.selected)

          return

        return
    }

module.exports.directive 'crtCheckboxGroup', $DI (crtLog, crtInputGroupDirective) ->
  crtInputGroupDirective('crtCheckboxGroup', require('./checkbox-group.tpl.html'))
